import { useEffect, useState } from 'react'
import { Users } from 'lucide-react'
import api from '../../services/api'

const RARITY_STYLE = {
  COMMON: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200',
  RARE: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  EPIC: 'bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300',
  LEGENDARY: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300'
}

/**
 * Motivational group badges the student earned with their Adaptive Teaching group. Celebrates shared
 * progress and teamwork; never punitive. Renders nothing when the student has no group badges.
 */
export default function StudentGroupBadges() {
  const [badges, setBadges] = useState([])
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const res = await api.get('/badges/me/group')
        if (!cancelled) setBadges(res.data?.data?.badges || [])
      } catch {
        if (!cancelled) setBadges([])
      } finally {
        if (!cancelled) setLoaded(true)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  if (!loaded || badges.length === 0) return null

  return (
    <section className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <div className="mb-3 flex items-center gap-2">
        <Users className="h-5 w-5 text-emerald-600" />
        <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Your group badges
        </h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {badges.map((b, i) => (
          <div
            key={`${b.code}-${b.unitNumber}-${i}`}
            className={`rounded-xl px-3 py-2 ${RARITY_STYLE[b.rarity] || RARITY_STYLE.COMMON}`}
            title={b.description}
          >
            <div className="text-sm font-semibold">{b.name}</div>
            <div className="text-[11px] opacity-80">{b.groupName || b.groupLabel}</div>
          </div>
        ))}
      </div>
    </section>
  )
}
